/**
 * cart-bff `/v1/checkout/*` endpoints.
 *
 * Each function takes a `HttpClient` plus the per-call inputs and returns
 * the validated response payload. Errors surface as `BffError` /
 * `NetworkError` from `http.ts` and propagate to the calling slice.
 */

import type {
  CheckoutConfirmRequestBody,
  CheckoutConfirmResponse,
  CheckoutCurrentResponse,
  PaymentSessionRequestBody,
  PaymentSessionResponse,
} from '../types/api';
import type { HttpClient } from './http';

const BASE = '/v1/checkout';

export interface CheckoutApi {
  getCurrentCart(input: { tokenId: string; countryCode: string }): Promise<CheckoutCurrentResponse>;
  createPaymentSession(input: {
    tokenId: string;
    countryCode: string;
    body: PaymentSessionRequestBody;
  }): Promise<PaymentSessionResponse>;
  confirm(input: {
    tokenId: string;
    countryCode: string;
    checkoutToken: string;
    body: CheckoutConfirmRequestBody;
  }): Promise<CheckoutConfirmResponse>;
}

export function createCheckoutApi(http: HttpClient): CheckoutApi {
  return {
    getCurrentCart: ({ tokenId, countryCode }) =>
      http.request<CheckoutCurrentResponse>('GET', `${BASE}`, {
        tokenId,
        countryCode,
      }),

    createPaymentSession: ({ tokenId, countryCode, body }) =>
      http.request<PaymentSessionResponse>('POST', `${BASE}/payment-session`, {
        tokenId,
        countryCode,
        body,
      }),

    confirm: ({ tokenId, countryCode, checkoutToken, body }) =>
      http.request<CheckoutConfirmResponse>('POST', `${BASE}/confirm`, {
        tokenId,
        countryCode,
        checkoutToken,
        body,
      }),
  };
}
